import React from "react";
import { Link } from "react-router-dom";
import { TbArrowBackUp } from "react-icons/tb";

const BundleListingDetails = ({
  bundleListingsById,
  setShowBundleListings,
}) => {
  return (
    <div className="container" style={{ marginTop: "20px" }}>
      <div
        onClick={() => setShowBundleListings(false)}
        style={{ cursor: "pointer" }}
      >
        <TbArrowBackUp
          style={{
            fontSize: "32px",
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
          }}
          className="back-arrow-new shadow me-2 mb-3 rounded-5 p-1 "
        />
      </div>

      <div className="my-listings mt-5 mb-5">
        <h3>{bundleListingsById?.title} Mockups</h3>
        <div className="row">
          {bundleListingsById?.listings?.length &&
            bundleListingsById?.listings.map((item) => (
              <div className=" col-6 col-lg-3 mb-4" key={item.id}>
                <div className="listing-card card shadow p-2">
                  <div className="listing-img overflow-hidden">
                    <Link
                      to={`/mockup?id=${item?.id}`}
                      className="card-img-wrapper position-relative"
                    >
                      <div className="" style={{ width: "18rem" }}>
                        <img
                          src={item?.use_main_file_as_thumbnail ? item?.compressed_file : item?.thumbnails?.[0]?.image}
                          className="card-img-top"
                          alt="Product"
                          style={{
                            width: "100%",
                            height: "220px",
                            borderTopRightRadius: "30px",
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                        />
                      </div>
                    </Link>
                  </div>
                  <div className="p-2 text-center">
                    <h5 className="card-title text-start mb-1 testelips">
                      {item?.title}
                    </h5>
                    <div
                      className="mb-4"
                      style={{ height: "40px", overflow: "hidden" }}
                    >
                      <p
                        className="text-start mb-1 mb-hidden"
                        style={{ margin: 0, fontSize: "14px" }}
                      >
                        {item?.short_description}
                      </p>
                    </div>
                    <div className="listing-footer flex-wrap d-flex gap-3 justify-content-center mb-2">
                      <Link
                        to={`/mockup-editor?id=${item?.id}`}
                        className="mb-hidden grey-use"
                      >
                        Use
                      </Link>
                    </div>

                    <div className="text-muted mt-2">
                      By{" "}
                      <Link
                        to={`/browse-mockups?name=${item?.user_id}`}
                        style={{ color: "#000" }}
                      >
                        {item?.user_name}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default BundleListingDetails;
